import script from "./ModeratorNews.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorNews.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorNews.vue?vue&type=style&index=0&id=9c4429e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4429e2"]])

export default __exports__